import { jsx as _jsx } from "react/jsx-runtime";
import { freddyTheme, IconButton, Link, useMediaQuery } from '@coolblue-development/freddy';
import { InfoCircled } from '@coolblue-development/icons';
import { Device } from '@coolblue-development/next-request-context';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { forwardRef } from 'react';
import { useTranslation } from '../../i18n/useTranslation.js';
import useTestId from '../utils/useTestId.js';
const MIN_TOUCH_TARGET_SIZE_PX = '24px';
export const ExplanationIcon = forwardRef(function ExplanationIcon({ onClick, testId, ml = 100, dialogId }, ref) {
    const { device } = useRequestContext();
    const { t } = useTranslation('explanationIcon');
    const testIdProps = useTestId(testId);
    const ariaProps = {
        'aria-haspopup': 'dialog',
        'aria-controls': dialogId,
    };
    const isMobile = useMediaQuery(freddyTheme.breakpoint.maxWidth('md'), device === Device.MOBILE);
    return isMobile ? (_jsx(Link, { ...testIdProps, ...ariaProps, onClick: onClick, ml: ml, component: "button", type: "button", sx: {
            minHeight: MIN_TOUCH_TARGET_SIZE_PX,
        }, ref: ref, children: `${t('label')}` })) : (_jsx(IconButton, { ...ariaProps, ...testIdProps, sx: {
            minWidth: MIN_TOUCH_TARGET_SIZE_PX,
            minHeight: MIN_TOUCH_TARGET_SIZE_PX,
        }, size: "xsmall", ml: ml, "aria-label": t('label'), onClick: onClick, type: "button", ref: ref, children: _jsx(InfoCircled, { color: "base", innerFill: "contrast" }) }));
});
export default ExplanationIcon;
//# sourceMappingURL=ExplanationIcon.js.map